export default __webpack_public_path__ + "static/optoppingen-mobile-5733ff22c8d6a07edd491b38aab87c58.svg";